import { Shelf, Image } from '@tracklib/kit'
import CenteredText from 'components/staticpages/blocks/frontpage/centeredtext'
import styles from './swipecarousel.css'

type Cover = {
  image: number
  title: string
  description: string
}

const Cover = ({ image, title, description }: Cover) => (
  <div>
    <div className={styles.image}>
      <Image image={image} alt={title} absolute />
    </div>
    <p className={styles.title}>{title}</p>
    <p className={styles.description}>{description}</p>
  </div>
)

type SwipeCarouselProps = {
  value: { items: Array<Cover>; label?: string; title?: string; description?: string; link_text?: string; link_url?: string }
}

const SwipeCarousel = ({ value: { items, label, title, description, link_text, link_url } }: SwipeCarouselProps): JSX.Element => (
  <section className={styles.wrap}>
    <CenteredText link_url={link_url} link_text={link_text} description={description} title={title} label={label} className={styles.text} />
    <Shelf className={styles.wrapper} arrows extraPad swipeClassName={styles.shelfSwipe}>
      {items?.map(item => (
        <Shelf.Item className={styles.cover} key={item.title}>
          <Cover image={item.image} title={item.title} description={item.description} />
        </Shelf.Item>
      ))}
    </Shelf>
  </section>
)

export default SwipeCarousel
